import { render, staticRenderFns } from "./AdminWebhooks.vue?vue&type=template&id=7a88003a&scoped=true"
import script from "./AdminWebhooks.vue?vue&type=script&lang=js"
export * from "./AdminWebhooks.vue?vue&type=script&lang=js"
import style0 from "@/assets/admin-styles.css?vue&type=style&index=0&id=7a88003a&prod&scoped=true&lang=css&external"
import style1 from "./AdminWebhooks.vue?vue&type=style&index=1&id=7a88003a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a88003a",
  null
  
)

export default component.exports